import { createFileRoute, Link } from '@tanstack/react-router'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/pro-solid-svg-icons'
export const Route = createFileRoute('/_auth/403')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ display: 'inline-flex' }}>
        <Typography
          variant="h1"
          sx={{ color: 'rgba(64, 64, 64, 0.5)', fontSize: 104, fontWeight: 'bold' }}
        >
          4
        </Typography>
        <Box sx={{ padding: '15px 0 10px 5px' }}>
          <Box
            sx={{
              height: 80,
              width: 80,
              backgroundColor: 'rgba(64, 64, 64, 0.5)',
              borderRadius: '50%',
              fontSize: 40,
              textAlign: 'center',
              color: 'white',
              padding: '15px',
              marginLeft: '10px',
              marginRight: '10px',
            }}
          >
            <FontAwesomeIcon icon={faLock} />
          </Box>
        </Box>
        <Typography
          variant="h1"
          sx={{ color: 'rgba(64, 64, 64, 0.5)', fontSize: 104, fontWeight: 'bold' }}
        >
          3
        </Typography>
      </Box>
      <Typography variant="h5" sx={{ color: 'rgba(64, 64, 64, 0.75)', fontWeight: 'bold', mb: 2 }}>
        {t('auth.accessDenied.title')}
      </Typography>
      <Typography variant="body2" sx={{ color: 'rgba(64, 64, 64, 0.75)' }}>
        {t('auth.accessDenied.body.line1')}
      </Typography>
      <Typography variant="body2" sx={{ color: 'rgba(64, 64, 64, 0.75)', mb: 2 }}>
        {t('auth.accessDenied.body.line2')}
      </Typography>
      <Button component={Link} to="/" variant="contained" color="primary">
        {t('auth.accessDenied.back')}
      </Button>
    </Box>
  )
}
